import React from 'react';

// TableHeader component
const TableHeader = ({ headers }) => (
  <thead>
    <tr className="flex gap-4 border-y-1 border-gray-200">
      {headers.map((header, index) => (
        <th
          key={header}
          className="flex-1 text-left p-3 text-sm font-normal relative"
        >
          {header}
          {index < headers.length - 1 && (
            <div
              className="absolute right-0"
              style={{
                borderRight: "2px solid #d1d5db",
                height: "16px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          )}
        </th>
      ))}
    </tr>
  </thead>
);

// RefractionInput component using register instead of Controller
const RefractionInput = ({ name, register }) => {
  console.log("Field name:", name);

  return (
    <input
      {...register(name)}
      type="text"
      className="w-full p-2 text-center rounded-md border-solid border-1 border-round-md border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary text-sm transition-all duration-200 inter-500 color-grey-15"
      style={{
        minWidth: "80px",
        height: "36px",
        background: "transparent",
      }}
    />
  );
};

// TableRow component using register
const TableRow = ({ rowType, headers, register, side, rowIndex, isLastRow }) => {
  const getFieldName = (header, side, rowIndex) => {
    const headerMap = {
      "SPH": "Sph",
      "VISION": "Vision", 
      "NECYLAR": "NeCylar",
      "AXIS": "Axis",
    };
    return `${side}_${headerMap[header]}${rowIndex}Dry_Refraction`;
  };

  return (
    <tr
      className={`flex gap-4 mb-2 ${
        !isLastRow ? "border-bottom-1 border-gray-200" : ""
      }`}
    >
      <td className="flex-1 text-left p-3 text-sm text-gray-600">{rowType}</td>
      {headers.slice(1).map((header, index) => (
        <td key={index} className="flex-1 p-3">
          <RefractionInput
            register={register}
            name={getFieldName(header, side, rowIndex)}
          />
        </td>
      ))}
    </tr>
  );
};

export default function RefractorTable({ register, contentTable }) {
  if (!register) {
    console.warn(
      "RefractorTable: register prop is required for form functionality"
    );
    return <div>Form register function is required</div>;
  }

  // Default content table structure
  contentTable = contentTable
    ? contentTable
    : [
        { head: "Dry Refraction", eye: "L" },
        { head: "Dry Refraction", eye: "R" },
      ];

  const headers = ["TYPE", "SPH", "NECYLAR", "AXIS", "VISION"];
  const rows = ["Distance", "Near"];

  const createRefractionTable = (tableData, side) => {
    return (
      <div
        className="overflow-x-auto"
        style={{ boxShadow: "0px 3px 12px 0px rgba(47, 43, 61, 0.14)" }}
      >
        <div className="flex flex-column p-3 font-medium bg-gray-100 border-b">
          {tableData.head}
        </div>
        <table className="w-full border-collapse bg-white">
          <TableHeader headers={headers} />
          <tbody>
            {rows.map((rowType, index) => (
              <TableRow
                key={rowType}
                rowType={rowType}
                headers={headers}
                register={register}
                side={side}
                rowIndex={index}
                isLastRow={index === rows.length - 1}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="md:flex flex-wrap max-w-full gap-5">
      {contentTable?.map((item, ind) => (
        <div
          key={ind}
          className="refraction-container flex-1 mb-5 md:mb-0 basis-auto overflow-x-auto"
        >
          <div>{createRefractionTable(item, item.eye)}</div>
        </div>
      ))}
    </div>
  );
}